import React, { useEffect, useState } from "react";
import { CheckMoreButton, HomeSlideContainer, HomeSlideInfosBox } from "../home.styles";
import { ReactComponent as AddCircle } from "../../../assets/icons/add-circle.svg";
import { IBannerReponse } from "../../../model/base/response/banner-response";
import { useMenuLinkNavigation } from "../../hooks/useMenuLinkNavigation";
import InstitutionalBannerSlide from "./institutional-banner-slide";

// Carrossel de banners da home (padrão e customizada); troca a cada 5s. Sem banners cadastrados, exibe os institucionais
export default function BannerSlide({ banners }: { banners: IBannerReponse[] }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const openLink = useMenuLinkNavigation();

  useEffect(() => {
    if (banners.length === 0) return;

    const interval = setInterval(() => {
      setActiveSlide((current) => (current >= banners.length - 1 ? 0 : current + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  if (banners.length === 0) return <InstitutionalBannerSlide />;

  const banner = banners[Math.min(activeSlide, banners.length - 1)];

  return (
    <section>
      <HomeSlideContainer>
        <img alt={banner.title || ''} src={banner.urlImage} />
        {banner.url && (
          <HomeSlideInfosBox>
            <CheckMoreButton onClick={() => openLink(banner.url, banner.openInNewTab ?? true)}>
              Saiba mais <AddCircle />
            </CheckMoreButton>
          </HomeSlideInfosBox>
        )}
      </HomeSlideContainer>
    </section>
  );
}
